import { OTAImageType } from '../types';
import { OTAReleaseDetails, OtaUpgradeStatus } from '../types/device';

export function sortList(list: any[], field: string): any[] {
    //if (alphaNumeric) return list.sort((a, b) => a[field].localeCompare(b[field], undefined, { numeric: true, sensitivity: 'base' }));
    return list.sort((a, b) => (a[field] > b[field] ? 1 : -1));
}

export function deriveImageType(otaReleaseDetails: OTAReleaseDetails, otaUpgradeStatus: OtaUpgradeStatus): string {
    let imageType = OTAImageType.package;

    if (otaUpgradeStatus.currentVersion !== null) {
        const upgradeVersion = otaReleaseDetails.version;
        const upgradeVersions = upgradeVersion.split('.');
        const upgradeMajorVersion = Number(upgradeVersions[0]);
        const upgradeMinorVersion = Number(upgradeVersions[1]);
        const upgradePatchVersion = Number(upgradeVersions[2]);

        const currentVersion = otaUpgradeStatus.currentVersion;
        const currentVersions = currentVersion.split('.');
        const currentMajorVersion = Number(currentVersions[0]);
        const currentMinorVersion = Number(currentVersions[1]);
        const currentPatchVersion = Number(currentVersions[2]);

        if (upgradeMajorVersion === currentMajorVersion && upgradeMinorVersion === currentMinorVersion) {
            if (upgradePatchVersion > currentPatchVersion && upgradePatchVersion - currentPatchVersion > 1) {
                imageType = OTAImageType.image; // Image Update
            }
        } else {
            imageType = OTAImageType.image; // Image Update
        }
        return imageType;
    }
    return imageType; // package Update
}
